<template>
  <shipblu-prompt
    class="shipment-modal"
    @close="closeModal"
    :active.sync="addFeesOnDeliveryModal"
    :title="type === 'add' ? `${$t('Add FOD Collections')}`: `${$t('Edit FOD Collections')}`"
    :buttons-hidden="true">
      <div class="grid grid-cols-2 gap-x-6 mb-8 mt-4">
        <div class="sm:col-span-1 col-span-2">
          <shipblu-select 
            :key="`governorate-${type}-${selectedGovernorate ? selectedGovernorate.id : 'null'}`"
            :inputValue="selectedGovernorate"
            :options="governorates" 
            :localize="true" 
            optionLabel="name" 
            inputId="governorate-input" 
            :required="true" 
            :labelPlaceholder="$t('Governorate')" 
            @selectedOptions="selectedGovernorateOptions($event[0])" 
            name="governorate"
            ref="governorateSelect"
            v-validate="data.governorate ? '' : 'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('governorate')">{{ errors.first('governorate') }}</span>
        </div>
        
        <div class="sm:col-span-1 col-span-2">
          <shipblu-input 
            v-validate="'required'" 
            name="cash amount" 
            :labelPlaceholder="$t('Cash Amount')" 
            :required="true" 
            v-model="data.cash_amount" 
            type="number"
          />
          <span class="text-danger text-sm" v-show="errors.has('cash amount')">{{ errors.first('cash amount') }}</span>
        </div>
      </div>
      
      <div class="grid grid-cols-2 gap-4 mt-4 font-semibold">
        <shipblu-button @click="closeModal" color="secondary" :textButton="$t('Cancel')" />
        <shipblu-button v-if="type === 'add'" @click="addFeesOnDelivery" :textButton="$t('Add')" />
        <shipblu-button v-else @click="updateFeesOnDelivery" :textButton="$t('Save')" />
      </div>
  </shipblu-prompt>
</template>

<script>
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import ShipbluSelect from '../../../layouts/components/ShipbluSelect.vue'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import common from '@/assets/utils/common'
import i18nData from '../../../i18n/i18nData.js'

export default {
  props: ['addFeesOnDeliveryModal', 'type', 'data', 'merchantId'],
  data () {
    return {
      apiURL: 'api/v1/merchants/',
      governorates: [],
      selectedGovernorate: null
    }
  },
  watch: {
    addFeesOnDeliveryModal (val) {
      if (val) {
        this.loadGovernorates().then(() => {
          this.setSelectedGovernorate()
        })
      } else {
        this.selectedGovernorate = null
      }
    }
  },
  methods: {
    loadGovernorates () {
      return new Promise((resolve) => {
        if (this.governorates.length > 0) {
          resolve(this.governorates)
          return
        }
        const govPromise = common.loadGovernorates(this)
        govPromise.then((results) => {
          this.governorates = results.data
          resolve(results.data)
        })
      })
    },
    setSelectedGovernorate () {
      if (this.type === 'edit' && this.data.governorate && this.governorates.length > 0) {
        let governorateId = this.data.governorate
        if (typeof this.data.governorate === 'object' && this.data.governorate.id) {
          governorateId = this.data.governorate.id
        }
        this.selectedGovernorate = this.governorates.find(gov => gov.id === governorateId) || null
        if (this.selectedGovernorate) {
          this.data.governorate = this.selectedGovernorate.id
        }
      } else if (this.type === 'add') {
        this.selectedGovernorate = null
      }
    },
    selectedGovernorateOptions (governorate) {
      if (governorate) {
        this.data.governorate = governorate.id
        this.selectedGovernorate = governorate
        this.$nextTick(() => {
          if (this.$refs.governorateValidation) {
            this.$validator.validate('governorate', governorate.id)
          }
        })
      }
    },
    updateFeesOnDelivery () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const url = `${this.apiURL}${this.merchantId}/fees-on-delivery/${this.data.id}/`
          const payload = {
            cash_amount: Number(this.data.cash_amount),
            governorate: this.data.governorate
          }

          sendRequest(false, false, this, url, 'put', payload, true,
            () => {
              this.$vs.notify({
                color:'success',
                title: i18nData[this.$i18n.locale]['Success'],
                text: i18nData[this.$i18n.locale]['Fees'] +  i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.$emit('addFeesOnDeliveryModal', false)
              this.$emit('loadData')
            }
          )
        }
      })
    },
    addFeesOnDelivery () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const url = `${this.apiURL}${this.merchantId}/fees-on-delivery/`
          const payload = {
            cash_amount: Number(this.data.cash_amount),
            governorate: this.data.governorate
          }
          sendRequest(false, false, this, url, 'post', payload, true,
            () => {
              this.$vs.notify({
                color:'success',
                title: i18nData[this.$i18n.locale]['Success'],
                text: i18nData[this.$i18n.locale]['Fees'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.saveLoading = false
              this.$emit('addFeesOnDeliveryModal', false)
              this.$emit('loadData')
            }
          )
        }
      })
    },
    closeModal () {
      this.selectedGovernorate = null
      this.$emit('addFeesOnDeliveryModal', false)
      this.$emit('loadData')
    }
  },
  components: {
    ShipbluPrompt,
    ShipbluSelect
  }
}
</script>